export default __webpack_public_path__ + "static/media/agent.4a00f59d.svg";